/* tslint:disable */
/* eslint-disable */
/**
 * Resell Search v2
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.19.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BaseSearchValue
 */
export interface BaseSearchValue {
    /**
     * 
     * @type {number}
     * @memberof BaseSearchValue
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseSearchValue
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseSearchValue
     */
    'description'?: string;
    /**
     * 
     * @type {Array<ExtendedSearchValue>}
     * @memberof BaseSearchValue
     */
    'values'?: Array<ExtendedSearchValue>;
    /**
     * 
     * @type {number}
     * @memberof BaseSearchValue
     */
    'productOptionSetSortOrder'?: number;
}
/**
 * 
 * @export
 * @interface BasicArrayItem
 */
export interface BasicArrayItem {
    /**
     * 
     * @type {number}
     * @memberof BasicArrayItem
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof BasicArrayItem
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface CustomerDto
 */
export interface CustomerDto {
    /**
     * 
     * @type {number}
     * @memberof CustomerDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'nickname'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerDto
     */
    'averageRating'?: number;
    /**
     * 
     * @type {RatingsDto}
     * @memberof CustomerDto
     */
    'ratings'?: RatingsDto;
    /**
     * 
     * @type {number}
     * @memberof CustomerDto
     */
    'totalSales'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerDto
     */
    'shipmentCompletionRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'lastLogin'?: CustomerDtoLastLoginEnum;
}

export const CustomerDtoLastLoginEnum = {
    ThisWeek: 'THIS_WEEK',
    _15DaysAgo: '15_DAYS_AGO',
    _1MonthAgo: '1_MONTH_AGO',
    _3MonthsAgo: '3_MONTHS_AGO',
    MoreThan3MonthsAgo: 'MORE_THAN_3_MONTHS_AGO'
} as const;

export type CustomerDtoLastLoginEnum = typeof CustomerDtoLastLoginEnum[keyof typeof CustomerDtoLastLoginEnum];

/**
 * 
 * @export
 * @interface ExtendedSearchValue
 */
export interface ExtendedSearchValue {
    /**
     * 
     * @type {number}
     * @memberof ExtendedSearchValue
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedSearchValue
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedSearchValue
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExtendedSearchValue
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedSearchValue
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedSearchValue
     */
    'extra'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendedSearchValue
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {Array<ProductOptionValueDto>}
     * @memberof ExtendedSearchValue
     */
    'values'?: Array<ProductOptionValueDto>;
}
/**
 * 
 * @export
 * @interface Group
 */
export interface Group {
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Group
     */
    'isGroup'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'groupReference'?: number;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'groupType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'groupDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'groupFrontImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'groupTitle'?: string;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'store'?: number;
    /**
     * 
     * @type {Array<ProductSize>}
     * @memberof Group
     */
    'sizes'?: Array<ProductSize>;
    /**
     * 
     * @type {ProductPrices}
     * @memberof Group
     */
    'prices'?: ProductPrices;
    /**
     * Grid ids
     * @type {Array<string>}
     * @memberof Group
     */
    'grids'?: Array<string>;
    /**
     * Universe ids
     * @type {Array<string>}
     * @memberof Group
     */
    'universes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GroupDetail
 */
export interface GroupDetail {
    /**
     * 
     * @type {number}
     * @memberof GroupDetail
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetail
     */
    'isGroup'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupDetail
     */
    'groupReference'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupDetail
     */
    'groupType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDetail
     */
    'groupDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDetail
     */
    'groupFrontImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDetail
     */
    'groupTitle'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupDetail
     */
    'groupColorId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDetail
     */
    'groupCategoryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDetail
     */
    'store'?: number;
    /**
     * 
     * @type {Array<BasicArrayItem>}
     * @memberof GroupDetail
     */
    'colors'?: Array<BasicArrayItem>;
    /**
     * 
     * @type {Array<BasicArrayItem>}
     * @memberof GroupDetail
     */
    'conditions'?: Array<BasicArrayItem>;
    /**
     * 
     * @type {Array<ProductSize>}
     * @memberof GroupDetail
     */
    'sizes'?: Array<ProductSize>;
    /**
     * 
     * @type {ProductPrices}
     * @memberof GroupDetail
     */
    'prices'?: ProductPrices;
}
/**
 * 
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'assetId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'amandaId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'deliveryUrl'?: string;
}
/**
 * 
 * @export
 * @interface PageProduct
 */
export interface PageProduct {
    /**
     * 
     * @type {number}
     * @memberof PageProduct
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageProduct
     */
    'totalPages'?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageProduct
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageProduct
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageProduct
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageProduct
     */
    'size'?: number;
    /**
     * 
     * @type {Array<Product>}
     * @memberof PageProduct
     */
    'content'?: Array<Product>;
    /**
     * 
     * @type {number}
     * @memberof PageProduct
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageProduct
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageProduct
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageProduct
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageProductGroup
 */
export interface PageProductGroup {
    /**
     * 
     * @type {number}
     * @memberof PageProductGroup
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageProductGroup
     */
    'totalPages'?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageProductGroup
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageProductGroup
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageProductGroup
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageProductGroup
     */
    'size'?: number;
    /**
     * 
     * @type {Array<Group>}
     * @memberof PageProductGroup
     */
    'content'?: Array<Group>;
    /**
     * 
     * @type {number}
     * @memberof PageProductGroup
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageProductGroup
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageProductGroup
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageProductGroup
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'offset'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageableObject
     */
    'sort'?: Sort;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'paged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'unpaged'?: boolean;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'sellerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'sellerShortName'?: string;
    /**
     * 
     * @type {CustomerDto}
     * @memberof Product
     */
    'seller'?: CustomerDto;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'catalogId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'catalogTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'catalogShortDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'catalogColorLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'catalogComposition'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'frontImage'?: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'categoryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'sizeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'colorId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'conditionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'sku'?: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'yearOfPurchase'?: number;
    /**
     * 
     * @type {ProductPriceDto}
     * @memberof Product
     */
    'price'?: ProductPriceDto;
    /**
     * 
     * @type {ProductPriceDto}
     * @memberof Product
     */
    'offerPrice'?: ProductPriceDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    'imageUrls'?: Array<string>;
    /**
     * 
     * @type {Array<Image>}
     * @memberof Product
     */
    'images'?: Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'needBackImage'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'publicationDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'rank'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'manualEntry'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'catalogDescription'?: string;
    /**
     * Grid ids
     * @type {Array<string>}
     * @memberof Product
     */
    'grids'?: Array<string>;
    /**
     * Universe ids
     * @type {Array<string>}
     * @memberof Product
     */
    'universes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ProductOptionValueDto
 */
export interface ProductOptionValueDto {
    /**
     * 
     * @type {number}
     * @memberof ProductOptionValueDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionValueDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionValueDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionValueDto
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionValueDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionValueDto
     */
    'extra'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductOptionValueDto
     */
    'disabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ProductPriceDto
 */
export interface ProductPriceDto {
    /**
     * 
     * @type {string}
     * @memberof ProductPriceDto
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    'exponent'?: number;
}
/**
 * 
 * @export
 * @interface ProductPrices
 */
export interface ProductPrices {
    /**
     * 
     * @type {ProductPriceDto}
     * @memberof ProductPrices
     */
    'min'?: ProductPriceDto;
    /**
     * 
     * @type {ProductPriceDto}
     * @memberof ProductPrices
     */
    'max'?: ProductPriceDto;
}
/**
 * 
 * @export
 * @interface ProductSize
 */
export interface ProductSize {
    /**
     * 
     * @type {number}
     * @memberof ProductSize
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductSize
     */
    'count'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductSize
     */
    'isHit'?: boolean;
}
/**
 * 
 * @export
 * @interface RatingsDto
 */
export interface RatingsDto {
    /**
     * 
     * @type {number}
     * @memberof RatingsDto
     */
    'productRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof RatingsDto
     */
    'sellerRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof RatingsDto
     */
    'shippingRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof RatingsDto
     */
    'autoRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof RatingsDto
     */
    'totalRatings'?: number;
    /**
     * 
     * @type {number}
     * @memberof RatingsDto
     */
    'totalAutoRatings'?: number;
}
/**
 * 
 * @export
 * @interface SearchFieldsDto
 */
export interface SearchFieldsDto {
    /**
     * 
     * @type {string}
     * @memberof SearchFieldsDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchFieldsDto
     */
    'categoryName'?: string;
    /**
     * 
     * @type {Array<BaseSearchValue>}
     * @memberof SearchFieldsDto
     */
    'values'?: Array<BaseSearchValue>;
    /**
     * 
     * @type {string}
     * @memberof SearchFieldsDto
     */
    'fieldName'?: string;
}
/**
 * 
 * @export
 * @interface SearchOptionsDto
 */
export interface SearchOptionsDto {
    /**
     * 
     * @type {Array<SearchSortDto>}
     * @memberof SearchOptionsDto
     */
    'sorting'?: Array<SearchSortDto>;
    /**
     * 
     * @type {Array<SearchFieldsDto>}
     * @memberof SearchOptionsDto
     */
    'filters'?: Array<SearchFieldsDto>;
}
/**
 * 
 * @export
 * @interface SearchSortDto
 */
export interface SearchSortDto {
    /**
     * 
     * @type {string}
     * @memberof SearchSortDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSortDto
     */
    'categoryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSortDto
     */
    'fieldName'?: string;
}
/**
 * 
 * @export
 * @interface Sort
 */
export interface Sort {
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'sorted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'empty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'unsorted'?: boolean;
}

/**
 * SearchGridAPIApi - axios parameter creator
 * @export
 */
export const SearchGridAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GET api/v2/search/filters/deep-url
         * @param {number} storeId 
         * @param {string} countryCode 
         * @param {string} sectionCode 
         * @param {string} viewToLoad 
         * @param {string} lang 
         * @param {number} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeepUrl: async (storeId: number, countryCode: string, sectionCode: string, viewToLoad: string, lang: string, productId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getDeepUrl', 'storeId', storeId)
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('getDeepUrl', 'countryCode', countryCode)
            // verify required parameter 'sectionCode' is not null or undefined
            assertParamExists('getDeepUrl', 'sectionCode', sectionCode)
            // verify required parameter 'viewToLoad' is not null or undefined
            assertParamExists('getDeepUrl', 'viewToLoad', viewToLoad)
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getDeepUrl', 'lang', lang)
            const localVarPath = `/api/v2/search/filters/deep-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (countryCode !== undefined) {
                localVarQueryParameter['countryCode'] = countryCode;
            }

            if (sectionCode !== undefined) {
                localVarQueryParameter['sectionCode'] = sectionCode;
            }

            if (viewToLoad !== undefined) {
                localVarQueryParameter['viewToLoad'] = viewToLoad;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Corresponding Grid For Zara
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [universeCode] 
         * @param {string} [gridCode] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridIdForZara: async (storeId: number, universeCode?: string, gridCode?: string, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getGridIdForZara', 'storeId', storeId)
            const localVarPath = `/api/v2/search/filters/gridmapping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (universeCode !== undefined) {
                localVarQueryParameter['universeCode'] = universeCode;
            }

            if (gridCode !== undefined) {
                localVarQueryParameter['gridCode'] = gridCode;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search a product by query
         * @param {number} gridId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProduct1: async (gridId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('searchProduct1', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('searchProduct1', 'storeId', storeId)
            const localVarPath = `/api/v2/search/grid/{gridId}/search`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (minPrice !== undefined) {
                localVarQueryParameter['minPrice'] = minPrice;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['maxPrice'] = maxPrice;
            }

            if (manualEntry !== undefined) {
                localVarQueryParameter['manualEntry'] = manualEntry;
            }

            if (minPublicationDateInMillis !== undefined) {
                localVarQueryParameter['minPublicationDateInMillis'] = minPublicationDateInMillis;
            }

            if (maxPublicationDateInMillis !== undefined) {
                localVarQueryParameter['maxPublicationDateInMillis'] = maxPublicationDateInMillis;
            }

            if (universeId) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (colorId) {
                localVarQueryParameter['colorId'] = colorId;
            }

            if (categoryId) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (sizeId) {
                localVarQueryParameter['sizeId'] = sizeId;
            }

            if (conditionId) {
                localVarQueryParameter['conditionId'] = conditionId;
            }

            if (shippingTypeId) {
                localVarQueryParameter['shippingTypeId'] = shippingTypeId;
            }

            if (customerStoreId !== undefined) {
                localVarQueryParameter['customerStoreId'] = customerStoreId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search a product by query bypassing the cache
         * @param {number} gridId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductWithoutCache1: async (gridId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('searchProductWithoutCache1', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('searchProductWithoutCache1', 'storeId', storeId)
            const localVarPath = `/api/v2/search/no-cache/grid/{gridId}/search`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (minPrice !== undefined) {
                localVarQueryParameter['minPrice'] = minPrice;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['maxPrice'] = maxPrice;
            }

            if (manualEntry !== undefined) {
                localVarQueryParameter['manualEntry'] = manualEntry;
            }

            if (minPublicationDateInMillis !== undefined) {
                localVarQueryParameter['minPublicationDateInMillis'] = minPublicationDateInMillis;
            }

            if (maxPublicationDateInMillis !== undefined) {
                localVarQueryParameter['maxPublicationDateInMillis'] = maxPublicationDateInMillis;
            }

            if (universeId) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (colorId) {
                localVarQueryParameter['colorId'] = colorId;
            }

            if (categoryId) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (sizeId) {
                localVarQueryParameter['sizeId'] = sizeId;
            }

            if (conditionId) {
                localVarQueryParameter['conditionId'] = conditionId;
            }

            if (shippingTypeId) {
                localVarQueryParameter['shippingTypeId'] = shippingTypeId;
            }

            if (customerStoreId !== undefined) {
                localVarQueryParameter['customerStoreId'] = customerStoreId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchGridAPIApi - functional programming interface
 * @export
 */
export const SearchGridAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchGridAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary GET api/v2/search/filters/deep-url
         * @param {number} storeId 
         * @param {string} countryCode 
         * @param {string} sectionCode 
         * @param {string} viewToLoad 
         * @param {string} lang 
         * @param {number} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeepUrl(storeId: number, countryCode: string, sectionCode: string, viewToLoad: string, lang: string, productId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeepUrl(storeId, countryCode, sectionCode, viewToLoad, lang, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Corresponding Grid For Zara
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [universeCode] 
         * @param {string} [gridCode] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGridIdForZara(storeId: number, universeCode?: string, gridCode?: string, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGridIdForZara(storeId, universeCode, gridCode, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search a product by query
         * @param {number} gridId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProduct1(gridId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProductGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProduct1(gridId, storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search a product by query bypassing the cache
         * @param {number} gridId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProductWithoutCache1(gridId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProductGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProductWithoutCache1(gridId, storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SearchGridAPIApi - factory interface
 * @export
 */
export const SearchGridAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchGridAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary GET api/v2/search/filters/deep-url
         * @param {number} storeId 
         * @param {string} countryCode 
         * @param {string} sectionCode 
         * @param {string} viewToLoad 
         * @param {string} lang 
         * @param {number} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeepUrl(storeId: number, countryCode: string, sectionCode: string, viewToLoad: string, lang: string, productId?: number, options?: any): AxiosPromise<string> {
            return localVarFp.getDeepUrl(storeId, countryCode, sectionCode, viewToLoad, lang, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Corresponding Grid For Zara
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [universeCode] 
         * @param {string} [gridCode] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridIdForZara(storeId: number, universeCode?: string, gridCode?: string, lang?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getGridIdForZara(storeId, universeCode, gridCode, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search a product by query
         * @param {number} gridId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProduct1(gridId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageProductGroup> {
            return localVarFp.searchProduct1(gridId, storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search a product by query bypassing the cache
         * @param {number} gridId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductWithoutCache1(gridId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageProductGroup> {
            return localVarFp.searchProductWithoutCache1(gridId, storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchGridAPIApi - interface
 * @export
 * @interface SearchGridAPIApi
 */
export interface SearchGridAPIApiInterface {
    /**
     * 
     * @summary GET api/v2/search/filters/deep-url
     * @param {number} storeId 
     * @param {string} countryCode 
     * @param {string} sectionCode 
     * @param {string} viewToLoad 
     * @param {string} lang 
     * @param {number} [productId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGridAPIApiInterface
     */
    getDeepUrl(storeId: number, countryCode: string, sectionCode: string, viewToLoad: string, lang: string, productId?: number, options?: AxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Get Corresponding Grid For Zara
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [universeCode] 
     * @param {string} [gridCode] 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGridAPIApiInterface
     */
    getGridIdForZara(storeId: number, universeCode?: string, gridCode?: string, lang?: string, options?: AxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Search a product by query
     * @param {number} gridId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGridAPIApiInterface
     */
    searchProduct1(gridId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageProductGroup>;

    /**
     * 
     * @summary Search a product by query bypassing the cache
     * @param {number} gridId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGridAPIApiInterface
     */
    searchProductWithoutCache1(gridId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageProductGroup>;

}

/**
 * SearchGridAPIApi - object-oriented interface
 * @export
 * @class SearchGridAPIApi
 * @extends {BaseAPI}
 */
export class SearchGridAPIApi extends BaseAPI implements SearchGridAPIApiInterface {
    /**
     * 
     * @summary GET api/v2/search/filters/deep-url
     * @param {number} storeId 
     * @param {string} countryCode 
     * @param {string} sectionCode 
     * @param {string} viewToLoad 
     * @param {string} lang 
     * @param {number} [productId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGridAPIApi
     */
    public getDeepUrl(storeId: number, countryCode: string, sectionCode: string, viewToLoad: string, lang: string, productId?: number, options?: AxiosRequestConfig) {
        return SearchGridAPIApiFp(this.configuration).getDeepUrl(storeId, countryCode, sectionCode, viewToLoad, lang, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Corresponding Grid For Zara
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [universeCode] 
     * @param {string} [gridCode] 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGridAPIApi
     */
    public getGridIdForZara(storeId: number, universeCode?: string, gridCode?: string, lang?: string, options?: AxiosRequestConfig) {
        return SearchGridAPIApiFp(this.configuration).getGridIdForZara(storeId, universeCode, gridCode, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search a product by query
     * @param {number} gridId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGridAPIApi
     */
    public searchProduct1(gridId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return SearchGridAPIApiFp(this.configuration).searchProduct1(gridId, storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search a product by query bypassing the cache
     * @param {number} gridId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGridAPIApi
     */
    public searchProductWithoutCache1(gridId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return SearchGridAPIApiFp(this.configuration).searchProductWithoutCache1(gridId, storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SearchGroupAPIApi - axios parameter creator
 * @export
 */
export const SearchGroupAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search within a group by query
         * @param {number} groupId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {boolean} [backoffice] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroupByIdAndQuery: async (groupId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('searchGroupByIdAndQuery', 'groupId', groupId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('searchGroupByIdAndQuery', 'storeId', storeId)
            const localVarPath = `/api/v2/search/group/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (minPrice !== undefined) {
                localVarQueryParameter['minPrice'] = minPrice;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['maxPrice'] = maxPrice;
            }

            if (manualEntry !== undefined) {
                localVarQueryParameter['manualEntry'] = manualEntry;
            }

            if (minPublicationDateInMillis !== undefined) {
                localVarQueryParameter['minPublicationDateInMillis'] = minPublicationDateInMillis;
            }

            if (maxPublicationDateInMillis !== undefined) {
                localVarQueryParameter['maxPublicationDateInMillis'] = maxPublicationDateInMillis;
            }

            if (universeId) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (colorId) {
                localVarQueryParameter['colorId'] = colorId;
            }

            if (categoryId) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (sizeId) {
                localVarQueryParameter['sizeId'] = sizeId;
            }

            if (conditionId) {
                localVarQueryParameter['conditionId'] = conditionId;
            }

            if (shippingTypeId) {
                localVarQueryParameter['shippingTypeId'] = shippingTypeId;
            }

            if (customerStoreId !== undefined) {
                localVarQueryParameter['customerStoreId'] = customerStoreId;
            }

            if (backoffice !== undefined) {
                localVarQueryParameter['backoffice'] = backoffice;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search a group by query
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [productId] 
         * @param {Array<number>} [groupId] 
         * @param {string} [query] 
         * @param {number} [gridId] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {boolean} [backoffice] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroupByQuery: async (storeId: number, productId?: Array<number>, groupId?: Array<number>, query?: string, gridId?: number, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('searchGroupByQuery', 'storeId', storeId)
            const localVarPath = `/api/v2/search/group/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productId) {
                localVarQueryParameter['productId'] = productId;
            }

            if (groupId) {
                localVarQueryParameter['groupId'] = groupId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (gridId !== undefined) {
                localVarQueryParameter['gridId'] = gridId;
            }

            if (minPrice !== undefined) {
                localVarQueryParameter['minPrice'] = minPrice;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['maxPrice'] = maxPrice;
            }

            if (manualEntry !== undefined) {
                localVarQueryParameter['manualEntry'] = manualEntry;
            }

            if (minPublicationDateInMillis !== undefined) {
                localVarQueryParameter['minPublicationDateInMillis'] = minPublicationDateInMillis;
            }

            if (maxPublicationDateInMillis !== undefined) {
                localVarQueryParameter['maxPublicationDateInMillis'] = maxPublicationDateInMillis;
            }

            if (universeId) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (colorId) {
                localVarQueryParameter['colorId'] = colorId;
            }

            if (categoryId) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (sizeId) {
                localVarQueryParameter['sizeId'] = sizeId;
            }

            if (conditionId) {
                localVarQueryParameter['conditionId'] = conditionId;
            }

            if (shippingTypeId) {
                localVarQueryParameter['shippingTypeId'] = shippingTypeId;
            }

            if (customerStoreId !== undefined) {
                localVarQueryParameter['customerStoreId'] = customerStoreId;
            }

            if (backoffice !== undefined) {
                localVarQueryParameter['backoffice'] = backoffice;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search a group by query without cache
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [productId] 
         * @param {Array<number>} [groupId] 
         * @param {string} [query] 
         * @param {number} [gridId] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {boolean} [backoffice] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroupByQueryWithoutCache: async (storeId: number, productId?: Array<number>, groupId?: Array<number>, query?: string, gridId?: number, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('searchGroupByQueryWithoutCache', 'storeId', storeId)
            const localVarPath = `/api/v2/search/no-cache/group/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productId) {
                localVarQueryParameter['productId'] = productId;
            }

            if (groupId) {
                localVarQueryParameter['groupId'] = groupId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (gridId !== undefined) {
                localVarQueryParameter['gridId'] = gridId;
            }

            if (minPrice !== undefined) {
                localVarQueryParameter['minPrice'] = minPrice;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['maxPrice'] = maxPrice;
            }

            if (manualEntry !== undefined) {
                localVarQueryParameter['manualEntry'] = manualEntry;
            }

            if (minPublicationDateInMillis !== undefined) {
                localVarQueryParameter['minPublicationDateInMillis'] = minPublicationDateInMillis;
            }

            if (maxPublicationDateInMillis !== undefined) {
                localVarQueryParameter['maxPublicationDateInMillis'] = maxPublicationDateInMillis;
            }

            if (universeId) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (colorId) {
                localVarQueryParameter['colorId'] = colorId;
            }

            if (categoryId) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (sizeId) {
                localVarQueryParameter['sizeId'] = sizeId;
            }

            if (conditionId) {
                localVarQueryParameter['conditionId'] = conditionId;
            }

            if (shippingTypeId) {
                localVarQueryParameter['shippingTypeId'] = shippingTypeId;
            }

            if (customerStoreId !== undefined) {
                localVarQueryParameter['customerStoreId'] = customerStoreId;
            }

            if (backoffice !== undefined) {
                localVarQueryParameter['backoffice'] = backoffice;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchGroupAPIApi - functional programming interface
 * @export
 */
export const SearchGroupAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchGroupAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Search within a group by query
         * @param {number} groupId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {boolean} [backoffice] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchGroupByIdAndQuery(groupId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchGroupByIdAndQuery(groupId, storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, backoffice, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search a group by query
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [productId] 
         * @param {Array<number>} [groupId] 
         * @param {string} [query] 
         * @param {number} [gridId] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {boolean} [backoffice] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchGroupByQuery(storeId: number, productId?: Array<number>, groupId?: Array<number>, query?: string, gridId?: number, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProductGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchGroupByQuery(storeId, productId, groupId, query, gridId, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, backoffice, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search a group by query without cache
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [productId] 
         * @param {Array<number>} [groupId] 
         * @param {string} [query] 
         * @param {number} [gridId] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {boolean} [backoffice] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchGroupByQueryWithoutCache(storeId: number, productId?: Array<number>, groupId?: Array<number>, query?: string, gridId?: number, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProductGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchGroupByQueryWithoutCache(storeId, productId, groupId, query, gridId, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, backoffice, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SearchGroupAPIApi - factory interface
 * @export
 */
export const SearchGroupAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchGroupAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Search within a group by query
         * @param {number} groupId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {boolean} [backoffice] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroupByIdAndQuery(groupId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<GroupDetail> {
            return localVarFp.searchGroupByIdAndQuery(groupId, storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, backoffice, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search a group by query
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [productId] 
         * @param {Array<number>} [groupId] 
         * @param {string} [query] 
         * @param {number} [gridId] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {boolean} [backoffice] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroupByQuery(storeId: number, productId?: Array<number>, groupId?: Array<number>, query?: string, gridId?: number, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageProductGroup> {
            return localVarFp.searchGroupByQuery(storeId, productId, groupId, query, gridId, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, backoffice, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search a group by query without cache
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [productId] 
         * @param {Array<number>} [groupId] 
         * @param {string} [query] 
         * @param {number} [gridId] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {boolean} [backoffice] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroupByQueryWithoutCache(storeId: number, productId?: Array<number>, groupId?: Array<number>, query?: string, gridId?: number, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageProductGroup> {
            return localVarFp.searchGroupByQueryWithoutCache(storeId, productId, groupId, query, gridId, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, backoffice, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchGroupAPIApi - interface
 * @export
 * @interface SearchGroupAPIApi
 */
export interface SearchGroupAPIApiInterface {
    /**
     * 
     * @summary Search within a group by query
     * @param {number} groupId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {boolean} [backoffice] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGroupAPIApiInterface
     */
    searchGroupByIdAndQuery(groupId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<GroupDetail>;

    /**
     * 
     * @summary Search a group by query
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<number>} [productId] 
     * @param {Array<number>} [groupId] 
     * @param {string} [query] 
     * @param {number} [gridId] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {boolean} [backoffice] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGroupAPIApiInterface
     */
    searchGroupByQuery(storeId: number, productId?: Array<number>, groupId?: Array<number>, query?: string, gridId?: number, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageProductGroup>;

    /**
     * 
     * @summary Search a group by query without cache
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<number>} [productId] 
     * @param {Array<number>} [groupId] 
     * @param {string} [query] 
     * @param {number} [gridId] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {boolean} [backoffice] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGroupAPIApiInterface
     */
    searchGroupByQueryWithoutCache(storeId: number, productId?: Array<number>, groupId?: Array<number>, query?: string, gridId?: number, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageProductGroup>;

}

/**
 * SearchGroupAPIApi - object-oriented interface
 * @export
 * @class SearchGroupAPIApi
 * @extends {BaseAPI}
 */
export class SearchGroupAPIApi extends BaseAPI implements SearchGroupAPIApiInterface {
    /**
     * 
     * @summary Search within a group by query
     * @param {number} groupId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {boolean} [backoffice] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGroupAPIApi
     */
    public searchGroupByIdAndQuery(groupId: number, storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return SearchGroupAPIApiFp(this.configuration).searchGroupByIdAndQuery(groupId, storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, backoffice, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search a group by query
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<number>} [productId] 
     * @param {Array<number>} [groupId] 
     * @param {string} [query] 
     * @param {number} [gridId] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {boolean} [backoffice] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGroupAPIApi
     */
    public searchGroupByQuery(storeId: number, productId?: Array<number>, groupId?: Array<number>, query?: string, gridId?: number, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return SearchGroupAPIApiFp(this.configuration).searchGroupByQuery(storeId, productId, groupId, query, gridId, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, backoffice, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search a group by query without cache
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<number>} [productId] 
     * @param {Array<number>} [groupId] 
     * @param {string} [query] 
     * @param {number} [gridId] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {boolean} [backoffice] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchGroupAPIApi
     */
    public searchGroupByQueryWithoutCache(storeId: number, productId?: Array<number>, groupId?: Array<number>, query?: string, gridId?: number, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, backoffice?: boolean, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return SearchGroupAPIApiFp(this.configuration).searchGroupByQueryWithoutCache(storeId, productId, groupId, query, gridId, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, backoffice, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SearchProductAPIApi - axios parameter creator
 * @export
 */
export const SearchProductAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a product by id
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [customerId] Id of logged customer, if any
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById: async (id: number, storeId: number, lang?: string, customerId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductById', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getProductById', 'storeId', storeId)
            const localVarPath = `/api/v2/search/product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get filters for products
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [universeId] 
         * @param {number} [gridId] 
         * @param {number} [groupId] 
         * @param {number} [sellerId] 
         * @param {boolean} [showDisabled] True by default. Set to false to show enabled options only.
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSearchOptions: async (storeId: number, universeId?: number, gridId?: number, groupId?: number, sellerId?: number, showDisabled?: boolean, customerStoreId?: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getProductSearchOptions', 'storeId', storeId)
            const localVarPath = `/api/v2/search/filters/for-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (universeId !== undefined) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (gridId !== undefined) {
                localVarQueryParameter['gridId'] = gridId;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }

            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }

            if (showDisabled !== undefined) {
                localVarQueryParameter['showDisabled'] = showDisabled;
            }

            if (customerStoreId !== undefined) {
                localVarQueryParameter['customerStoreId'] = customerStoreId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get filters for products by gridId
         * @param {number} gridId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [groupId] 
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSearchOptionsByGrid: async (gridId: number, storeId: number, groupId?: number, customerStoreId?: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('getProductSearchOptionsByGrid', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getProductSearchOptionsByGrid', 'storeId', storeId)
            const localVarPath = `/api/v2/search/filters/for-products/by-grid/{gridId}`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }

            if (customerStoreId !== undefined) {
                localVarQueryParameter['customerStoreId'] = customerStoreId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get filters for products by groupId
         * @param {number} groupId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSearchOptionsByGroup: async (groupId: number, storeId: number, customerStoreId?: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getProductSearchOptionsByGroup', 'groupId', groupId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getProductSearchOptionsByGroup', 'storeId', storeId)
            const localVarPath = `/api/v2/search/filters/for-products/by-group/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerStoreId !== undefined) {
                localVarQueryParameter['customerStoreId'] = customerStoreId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get filters for products by sellerId
         * @param {number} sellerId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSearchOptionsBySeller: async (sellerId: number, storeId: number, customerStoreId?: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sellerId' is not null or undefined
            assertParamExists('getProductSearchOptionsBySeller', 'sellerId', sellerId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getProductSearchOptionsBySeller', 'storeId', storeId)
            const localVarPath = `/api/v2/search/filters/for-products/by-seller/{sellerId}`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerStoreId !== undefined) {
                localVarQueryParameter['customerStoreId'] = customerStoreId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get filters for products by universeId
         * @param {number} universeId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSearchOptionsByUniverse: async (universeId: number, storeId: number, customerStoreId?: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'universeId' is not null or undefined
            assertParamExists('getProductSearchOptionsByUniverse', 'universeId', universeId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getProductSearchOptionsByUniverse', 'storeId', storeId)
            const localVarPath = `/api/v2/search/filters/for-products/by-universe/{universeId}`
                .replace(`{${"universeId"}}`, encodeURIComponent(String(universeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerStoreId !== undefined) {
                localVarQueryParameter['customerStoreId'] = customerStoreId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get available products list
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailableProducts: async (storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listAvailableProducts', 'storeId', storeId)
            const localVarPath = `/api/v2/search/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search a product by query
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {Array<number>} [groupId] 
         * @param {Array<number>} [productId] 
         * @param {number} [sellerId] seller id
         * @param {Array<number>} [excludeProductId] 
         * @param {string} [cartCode] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProduct: async (storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, groupId?: Array<number>, productId?: Array<number>, sellerId?: number, excludeProductId?: Array<number>, cartCode?: string, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('searchProduct', 'storeId', storeId)
            const localVarPath = `/api/v2/search/products/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (minPrice !== undefined) {
                localVarQueryParameter['minPrice'] = minPrice;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['maxPrice'] = maxPrice;
            }

            if (manualEntry !== undefined) {
                localVarQueryParameter['manualEntry'] = manualEntry;
            }

            if (minPublicationDateInMillis !== undefined) {
                localVarQueryParameter['minPublicationDateInMillis'] = minPublicationDateInMillis;
            }

            if (maxPublicationDateInMillis !== undefined) {
                localVarQueryParameter['maxPublicationDateInMillis'] = maxPublicationDateInMillis;
            }

            if (universeId) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (colorId) {
                localVarQueryParameter['colorId'] = colorId;
            }

            if (categoryId) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (sizeId) {
                localVarQueryParameter['sizeId'] = sizeId;
            }

            if (conditionId) {
                localVarQueryParameter['conditionId'] = conditionId;
            }

            if (shippingTypeId) {
                localVarQueryParameter['shippingTypeId'] = shippingTypeId;
            }

            if (customerStoreId !== undefined) {
                localVarQueryParameter['customerStoreId'] = customerStoreId;
            }

            if (groupId) {
                localVarQueryParameter['groupId'] = groupId;
            }

            if (productId) {
                localVarQueryParameter['productId'] = productId;
            }

            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }

            if (excludeProductId) {
                localVarQueryParameter['excludeProductId'] = excludeProductId;
            }

            if (cartCode !== undefined) {
                localVarQueryParameter['cartCode'] = cartCode;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search a product by query bypassing the cache
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {Array<number>} [groupId] 
         * @param {Array<number>} [productId] 
         * @param {number} [sellerId] seller id
         * @param {Array<number>} [excludeProductId] 
         * @param {string} [cartCode] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductWithoutCache: async (storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, groupId?: Array<number>, productId?: Array<number>, sellerId?: number, excludeProductId?: Array<number>, cartCode?: string, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('searchProductWithoutCache', 'storeId', storeId)
            const localVarPath = `/api/v2/search/no-cache/products/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (minPrice !== undefined) {
                localVarQueryParameter['minPrice'] = minPrice;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['maxPrice'] = maxPrice;
            }

            if (manualEntry !== undefined) {
                localVarQueryParameter['manualEntry'] = manualEntry;
            }

            if (minPublicationDateInMillis !== undefined) {
                localVarQueryParameter['minPublicationDateInMillis'] = minPublicationDateInMillis;
            }

            if (maxPublicationDateInMillis !== undefined) {
                localVarQueryParameter['maxPublicationDateInMillis'] = maxPublicationDateInMillis;
            }

            if (universeId) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (colorId) {
                localVarQueryParameter['colorId'] = colorId;
            }

            if (categoryId) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (sizeId) {
                localVarQueryParameter['sizeId'] = sizeId;
            }

            if (conditionId) {
                localVarQueryParameter['conditionId'] = conditionId;
            }

            if (shippingTypeId) {
                localVarQueryParameter['shippingTypeId'] = shippingTypeId;
            }

            if (customerStoreId !== undefined) {
                localVarQueryParameter['customerStoreId'] = customerStoreId;
            }

            if (groupId) {
                localVarQueryParameter['groupId'] = groupId;
            }

            if (productId) {
                localVarQueryParameter['productId'] = productId;
            }

            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }

            if (excludeProductId) {
                localVarQueryParameter['excludeProductId'] = excludeProductId;
            }

            if (cartCode !== undefined) {
                localVarQueryParameter['cartCode'] = cartCode;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchProductAPIApi - functional programming interface
 * @export
 */
export const SearchProductAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchProductAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a product by id
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [customerId] Id of logged customer, if any
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductById(id: number, storeId: number, lang?: string, customerId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductById(id, storeId, lang, customerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get filters for products
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [universeId] 
         * @param {number} [gridId] 
         * @param {number} [groupId] 
         * @param {number} [sellerId] 
         * @param {boolean} [showDisabled] True by default. Set to false to show enabled options only.
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSearchOptions(storeId: number, universeId?: number, gridId?: number, groupId?: number, sellerId?: number, showDisabled?: boolean, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchOptionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSearchOptions(storeId, universeId, gridId, groupId, sellerId, showDisabled, customerStoreId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get filters for products by gridId
         * @param {number} gridId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [groupId] 
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSearchOptionsByGrid(gridId: number, storeId: number, groupId?: number, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchOptionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSearchOptionsByGrid(gridId, storeId, groupId, customerStoreId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get filters for products by groupId
         * @param {number} groupId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSearchOptionsByGroup(groupId: number, storeId: number, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchOptionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSearchOptionsByGroup(groupId, storeId, customerStoreId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get filters for products by sellerId
         * @param {number} sellerId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSearchOptionsBySeller(sellerId: number, storeId: number, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchOptionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSearchOptionsBySeller(sellerId, storeId, customerStoreId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get filters for products by universeId
         * @param {number} universeId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSearchOptionsByUniverse(universeId: number, storeId: number, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchOptionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSearchOptionsByUniverse(universeId, storeId, customerStoreId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get available products list
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAvailableProducts(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAvailableProducts(storeId, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search a product by query
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {Array<number>} [groupId] 
         * @param {Array<number>} [productId] 
         * @param {number} [sellerId] seller id
         * @param {Array<number>} [excludeProductId] 
         * @param {string} [cartCode] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProduct(storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, groupId?: Array<number>, productId?: Array<number>, sellerId?: number, excludeProductId?: Array<number>, cartCode?: string, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProduct(storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, groupId, productId, sellerId, excludeProductId, cartCode, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search a product by query bypassing the cache
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {Array<number>} [groupId] 
         * @param {Array<number>} [productId] 
         * @param {number} [sellerId] seller id
         * @param {Array<number>} [excludeProductId] 
         * @param {string} [cartCode] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProductWithoutCache(storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, groupId?: Array<number>, productId?: Array<number>, sellerId?: number, excludeProductId?: Array<number>, cartCode?: string, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProductWithoutCache(storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, groupId, productId, sellerId, excludeProductId, cartCode, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SearchProductAPIApi - factory interface
 * @export
 */
export const SearchProductAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchProductAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a product by id
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [customerId] Id of logged customer, if any
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById(id: number, storeId: number, lang?: string, customerId?: number, options?: any): AxiosPromise<Product> {
            return localVarFp.getProductById(id, storeId, lang, customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get filters for products
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [universeId] 
         * @param {number} [gridId] 
         * @param {number} [groupId] 
         * @param {number} [sellerId] 
         * @param {boolean} [showDisabled] True by default. Set to false to show enabled options only.
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSearchOptions(storeId: number, universeId?: number, gridId?: number, groupId?: number, sellerId?: number, showDisabled?: boolean, customerStoreId?: number, lang?: string, options?: any): AxiosPromise<SearchOptionsDto> {
            return localVarFp.getProductSearchOptions(storeId, universeId, gridId, groupId, sellerId, showDisabled, customerStoreId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get filters for products by gridId
         * @param {number} gridId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [groupId] 
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSearchOptionsByGrid(gridId: number, storeId: number, groupId?: number, customerStoreId?: number, lang?: string, options?: any): AxiosPromise<SearchOptionsDto> {
            return localVarFp.getProductSearchOptionsByGrid(gridId, storeId, groupId, customerStoreId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get filters for products by groupId
         * @param {number} groupId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSearchOptionsByGroup(groupId: number, storeId: number, customerStoreId?: number, lang?: string, options?: any): AxiosPromise<SearchOptionsDto> {
            return localVarFp.getProductSearchOptionsByGroup(groupId, storeId, customerStoreId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get filters for products by sellerId
         * @param {number} sellerId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSearchOptionsBySeller(sellerId: number, storeId: number, customerStoreId?: number, lang?: string, options?: any): AxiosPromise<SearchOptionsDto> {
            return localVarFp.getProductSearchOptionsBySeller(sellerId, storeId, customerStoreId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get filters for products by universeId
         * @param {number} universeId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [customerStoreId] guest store id
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSearchOptionsByUniverse(universeId: number, storeId: number, customerStoreId?: number, lang?: string, options?: any): AxiosPromise<SearchOptionsDto> {
            return localVarFp.getProductSearchOptionsByUniverse(universeId, storeId, customerStoreId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get available products list
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailableProducts(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageProduct> {
            return localVarFp.listAvailableProducts(storeId, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search a product by query
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {Array<number>} [groupId] 
         * @param {Array<number>} [productId] 
         * @param {number} [sellerId] seller id
         * @param {Array<number>} [excludeProductId] 
         * @param {string} [cartCode] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProduct(storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, groupId?: Array<number>, productId?: Array<number>, sellerId?: number, excludeProductId?: Array<number>, cartCode?: string, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageProduct> {
            return localVarFp.searchProduct(storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, groupId, productId, sellerId, excludeProductId, cartCode, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search a product by query bypassing the cache
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {boolean} [manualEntry] 
         * @param {number} [minPublicationDateInMillis] 
         * @param {number} [maxPublicationDateInMillis] 
         * @param {Array<number>} [universeId] 
         * @param {Array<number>} [colorId] 
         * @param {Array<number>} [categoryId] 
         * @param {Array<number>} [sizeId] 
         * @param {Array<number>} [conditionId] 
         * @param {Array<number>} [shippingTypeId] 
         * @param {number} [customerStoreId] guest store id
         * @param {Array<number>} [groupId] 
         * @param {Array<number>} [productId] 
         * @param {number} [sellerId] seller id
         * @param {Array<number>} [excludeProductId] 
         * @param {string} [cartCode] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductWithoutCache(storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, groupId?: Array<number>, productId?: Array<number>, sellerId?: number, excludeProductId?: Array<number>, cartCode?: string, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageProduct> {
            return localVarFp.searchProductWithoutCache(storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, groupId, productId, sellerId, excludeProductId, cartCode, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchProductAPIApi - interface
 * @export
 * @interface SearchProductAPIApi
 */
export interface SearchProductAPIApiInterface {
    /**
     * 
     * @summary Get a product by id
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [customerId] Id of logged customer, if any
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApiInterface
     */
    getProductById(id: number, storeId: number, lang?: string, customerId?: number, options?: AxiosRequestConfig): AxiosPromise<Product>;

    /**
     * 
     * @summary Get filters for products
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [universeId] 
     * @param {number} [gridId] 
     * @param {number} [groupId] 
     * @param {number} [sellerId] 
     * @param {boolean} [showDisabled] True by default. Set to false to show enabled options only.
     * @param {number} [customerStoreId] guest store id
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApiInterface
     */
    getProductSearchOptions(storeId: number, universeId?: number, gridId?: number, groupId?: number, sellerId?: number, showDisabled?: boolean, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<SearchOptionsDto>;

    /**
     * 
     * @summary Get filters for products by gridId
     * @param {number} gridId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [groupId] 
     * @param {number} [customerStoreId] guest store id
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApiInterface
     */
    getProductSearchOptionsByGrid(gridId: number, storeId: number, groupId?: number, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<SearchOptionsDto>;

    /**
     * 
     * @summary Get filters for products by groupId
     * @param {number} groupId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [customerStoreId] guest store id
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApiInterface
     */
    getProductSearchOptionsByGroup(groupId: number, storeId: number, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<SearchOptionsDto>;

    /**
     * 
     * @summary Get filters for products by sellerId
     * @param {number} sellerId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [customerStoreId] guest store id
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApiInterface
     */
    getProductSearchOptionsBySeller(sellerId: number, storeId: number, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<SearchOptionsDto>;

    /**
     * 
     * @summary Get filters for products by universeId
     * @param {number} universeId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [customerStoreId] guest store id
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApiInterface
     */
    getProductSearchOptionsByUniverse(universeId: number, storeId: number, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<SearchOptionsDto>;

    /**
     * 
     * @summary Get available products list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApiInterface
     */
    listAvailableProducts(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageProduct>;

    /**
     * 
     * @summary Search a product by query
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {Array<number>} [groupId] 
     * @param {Array<number>} [productId] 
     * @param {number} [sellerId] seller id
     * @param {Array<number>} [excludeProductId] 
     * @param {string} [cartCode] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApiInterface
     */
    searchProduct(storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, groupId?: Array<number>, productId?: Array<number>, sellerId?: number, excludeProductId?: Array<number>, cartCode?: string, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageProduct>;

    /**
     * 
     * @summary Search a product by query bypassing the cache
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {Array<number>} [groupId] 
     * @param {Array<number>} [productId] 
     * @param {number} [sellerId] seller id
     * @param {Array<number>} [excludeProductId] 
     * @param {string} [cartCode] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApiInterface
     */
    searchProductWithoutCache(storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, groupId?: Array<number>, productId?: Array<number>, sellerId?: number, excludeProductId?: Array<number>, cartCode?: string, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageProduct>;

}

/**
 * SearchProductAPIApi - object-oriented interface
 * @export
 * @class SearchProductAPIApi
 * @extends {BaseAPI}
 */
export class SearchProductAPIApi extends BaseAPI implements SearchProductAPIApiInterface {
    /**
     * 
     * @summary Get a product by id
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [customerId] Id of logged customer, if any
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApi
     */
    public getProductById(id: number, storeId: number, lang?: string, customerId?: number, options?: AxiosRequestConfig) {
        return SearchProductAPIApiFp(this.configuration).getProductById(id, storeId, lang, customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get filters for products
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [universeId] 
     * @param {number} [gridId] 
     * @param {number} [groupId] 
     * @param {number} [sellerId] 
     * @param {boolean} [showDisabled] True by default. Set to false to show enabled options only.
     * @param {number} [customerStoreId] guest store id
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApi
     */
    public getProductSearchOptions(storeId: number, universeId?: number, gridId?: number, groupId?: number, sellerId?: number, showDisabled?: boolean, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig) {
        return SearchProductAPIApiFp(this.configuration).getProductSearchOptions(storeId, universeId, gridId, groupId, sellerId, showDisabled, customerStoreId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get filters for products by gridId
     * @param {number} gridId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [groupId] 
     * @param {number} [customerStoreId] guest store id
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApi
     */
    public getProductSearchOptionsByGrid(gridId: number, storeId: number, groupId?: number, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig) {
        return SearchProductAPIApiFp(this.configuration).getProductSearchOptionsByGrid(gridId, storeId, groupId, customerStoreId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get filters for products by groupId
     * @param {number} groupId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [customerStoreId] guest store id
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApi
     */
    public getProductSearchOptionsByGroup(groupId: number, storeId: number, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig) {
        return SearchProductAPIApiFp(this.configuration).getProductSearchOptionsByGroup(groupId, storeId, customerStoreId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get filters for products by sellerId
     * @param {number} sellerId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [customerStoreId] guest store id
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApi
     */
    public getProductSearchOptionsBySeller(sellerId: number, storeId: number, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig) {
        return SearchProductAPIApiFp(this.configuration).getProductSearchOptionsBySeller(sellerId, storeId, customerStoreId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get filters for products by universeId
     * @param {number} universeId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [customerStoreId] guest store id
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApi
     */
    public getProductSearchOptionsByUniverse(universeId: number, storeId: number, customerStoreId?: number, lang?: string, options?: AxiosRequestConfig) {
        return SearchProductAPIApiFp(this.configuration).getProductSearchOptionsByUniverse(universeId, storeId, customerStoreId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get available products list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApi
     */
    public listAvailableProducts(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return SearchProductAPIApiFp(this.configuration).listAvailableProducts(storeId, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search a product by query
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {Array<number>} [groupId] 
     * @param {Array<number>} [productId] 
     * @param {number} [sellerId] seller id
     * @param {Array<number>} [excludeProductId] 
     * @param {string} [cartCode] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApi
     */
    public searchProduct(storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, groupId?: Array<number>, productId?: Array<number>, sellerId?: number, excludeProductId?: Array<number>, cartCode?: string, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return SearchProductAPIApiFp(this.configuration).searchProduct(storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, groupId, productId, sellerId, excludeProductId, cartCode, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search a product by query bypassing the cache
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {boolean} [manualEntry] 
     * @param {number} [minPublicationDateInMillis] 
     * @param {number} [maxPublicationDateInMillis] 
     * @param {Array<number>} [universeId] 
     * @param {Array<number>} [colorId] 
     * @param {Array<number>} [categoryId] 
     * @param {Array<number>} [sizeId] 
     * @param {Array<number>} [conditionId] 
     * @param {Array<number>} [shippingTypeId] 
     * @param {number} [customerStoreId] guest store id
     * @param {Array<number>} [groupId] 
     * @param {Array<number>} [productId] 
     * @param {number} [sellerId] seller id
     * @param {Array<number>} [excludeProductId] 
     * @param {string} [cartCode] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchProductAPIApi
     */
    public searchProductWithoutCache(storeId: number, query?: string, minPrice?: number, maxPrice?: number, manualEntry?: boolean, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, colorId?: Array<number>, categoryId?: Array<number>, sizeId?: Array<number>, conditionId?: Array<number>, shippingTypeId?: Array<number>, customerStoreId?: number, groupId?: Array<number>, productId?: Array<number>, sellerId?: number, excludeProductId?: Array<number>, cartCode?: string, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return SearchProductAPIApiFp(this.configuration).searchProductWithoutCache(storeId, query, minPrice, maxPrice, manualEntry, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, colorId, categoryId, sizeId, conditionId, shippingTypeId, customerStoreId, groupId, productId, sellerId, excludeProductId, cartCode, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


